export const collaboratorGender = ['homme', 'femme'] as const
export type CollaboratorGender = (typeof collaboratorGender)[number]

export const collaboratorGenderLabel: Record<CollaboratorGender, string> = {
  homme: 'H',
  femme: 'F',
}
